import React from 'react';
import styled from 'styled-components';

const s = {
  Grid: styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  `,
  DummyItem: styled.div`
    height: 0px;
    overflow: hidden;
  `,
};

const getDummyItems = (items: Array<any>, min?: number): Array<any> => {
  const length = Math.max(min || 0, items.length);
  const filler = items[0];
  const dummyItems: Array<any> = [];
  for (let i = 1; i < length; i++) {
    dummyItems.push(filler);
  }
  return dummyItems;
};

export type GridProps = {
  items: Array<React.ReactElement>;
  minLength?: number;
  className?: string;
};

const Grid: React.FC<GridProps> = ({ items, minLength = 0, className }) => {
  return (
    <s.Grid className={className}>
      {items.map((item, i) => (
        <React.Fragment key={i}>{item}</React.Fragment>
      ))}
      {/*
       * this is a flexbox hack to properly align the last row of a grid.
       * see https://stackoverflow.com/a/22018710
       */}
      {getDummyItems(items, minLength).map((item, i) => (
        <s.DummyItem key={i}>{item}</s.DummyItem>
      ))}
    </s.Grid>
  );
};

export default Grid;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Grid.tsx